import { useLocation } from "@remix-run/react";
import classNames from "classnames";
import { STEPS } from "~/constants";

export function Stepper() {
  const { pathname } = useLocation();
  const currentStep = STEPS.find((step) => step.href === pathname)?.id || 1;
  return (
    <nav aria-label="Progress" className="my-8 hidden md:block">
      <ol className="flex items-center justify-center">
        {STEPS.map((step, stepIdx) => (
          <li
            key={step.label}
            className={classNames("relative flex w-52 flex-col items-center")}
          >
            <div className="flex items-center">
              <div
                className={classNames(
                  "relative flex h-10 w-10 items-center justify-center rounded-full",
                  step.id < currentStep
                    ? "bg-primary-600 text-white"
                    : step.id === currentStep
                      ? "border-2 border-primary-800 bg-neutral-50 text-primary-600"
                      : "bg-gray-100",
                )}
              >
                <span className="text-sm font-medium">{step.id}</span>
              </div>
              {stepIdx !== STEPS.length - 1 && (
                <div
                  className={classNames(
                    "absolute left-[64%] h-0.5 w-36 -translate-y-1/2 transform",
                    step.id < currentStep ? "bg-primary-600" : "bg-gray-400",
                  )}
                />
              )}
            </div>
            <span
              className={classNames(
                "mt-2 w-max text-center text-sm font-medium",
                step.id <= currentStep ? "text-primary-600" : "text-zinc-900",
              )}
            >
              {step.label}
            </span>
          </li>
        ))}
      </ol>
    </nav>
  );
}
